__turbopack_context__.v({
  "card": "AboutParking-module-scss-module__fntS-W__card",
  "cardsContainer": "AboutParking-module-scss-module__fntS-W__cardsContainer",
  "description": "AboutParking-module-scss-module__fntS-W__description",
  "description__point": "AboutParking-module-scss-module__fntS-W__description__point",
  "img": "AboutParking-module-scss-module__fntS-W__img",
  "imgBox": "AboutParking-module-scss-module__fntS-W__imgBox",
  "list": "AboutParking-module-scss-module__fntS-W__list",
  "listsGroup": "AboutParking-module-scss-module__fntS-W__listsGroup",
  "subtitle": "AboutParking-module-scss-module__fntS-W__subtitle",
  "textContent": "AboutParking-module-scss-module__fntS-W__textContent",
  "title": "AboutParking-module-scss-module__fntS-W__title",
  "wrapper": "AboutParking-module-scss-module__fntS-W__wrapper",
});
